export default __webpack_public_path__ + "static/media/bg-img.ac97d736.png";